"use client";

import { usePathname, useSearchParams } from "next/navigation";

export default function Globals({ currency, siteId }: { currency: string; siteId: string }) {
  const searchParams = useSearchParams();
  const pathname = usePathname();

  if (!global.window) return null;

  // Site ID
  window.siteId = siteId;

  // Currency
  window.currency = currency || "USD";

  // Leg index - must be 0 or 1.
  // Explicit
  let legIndex: 0 | 1;
  let searchParamsLegIndex = searchParams?.get("leg_index");
  if (searchParamsLegIndex) legIndex = Number(searchParamsLegIndex) as 0 | 1;

  // Implicit - At least at the moment useSearchParams doesn't see query parameters when they are the result of a rewrite.
  // This is a work-around.
  if (
    pathname.endsWith("/return") ||
    pathname.endsWith("/return_services") ||
    pathname.endsWith("/return_extras") ||
    searchParams.get("leg_index") === "1"
  ) {
    legIndex = 1;
  } else {
    legIndex = 0;
  }

  window.legIndex = legIndex as 0 | 1;

  return null;
}
